export * as _ from './misc';

import sorts from './sorts';
import getSolrResult from './solr';

import type { TaxonomyItem } from '../utils/munge';

interface DrupalNode {
  name: string;
  nid: string;
}

const unwrap = async (res: Response): Promise<any> => res.json();
const options: RequestInit = {};

const base = `//www.drjcertification.org/api/v1`;
// const base = `//drjcert.lndo.site/api/v1`;

export async function getTaxonomyData(): Promise<TaxonomyItem[]> {
  return (
    fetch(`${base}/taxonomy/csi`, options)
      .then(unwrap)
      // import static data only if necessary
      .catch(() => import('../data/csi.json').then(mod => mod.default))
  );
}

export async function getCompanyData(): Promise<DrupalNode[]> {
  return fetch(`${base}/companies`, options)
    .then(unwrap)
    .catch(() => import('../data/clients.json').then(mod => mod.default));
}

export async function getProductData(): Promise<DrupalNode[]> {
  return fetch(`${base}/products`, options)
    .then(unwrap)
    .catch(() => import('../data/products.json').then(mod => mod.default));
}

export async function getTERNumberData(): Promise<DrupalNode[]> {
  return fetch(`${base}/numbers`, options)
    .then(unwrap)
    .catch(() => import('../data/numbers.json').then(mod => mod.default));
}

export { mungeSearchResult } from './munge';
export { getFilterParams, getSortParams, getFacetParams } from './search';
export { sorts, getSolrResult };
